module.exports = __webpack_public_path__ + "img/Dashboard.5b68e081.svg";